import React from 'react'
// import ChooseTipoProdutoDialog from './chooseTipoProdutoDialog'
import ConstantsUtil from '../../../context/constantsUtil'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import DialogFooter from '../../dialogFooter'
import GeneralServices from '../../../app/service/generalServices'
import SelectMenu from '../../selectMenu'
import { Dropdown } from 'primereact/dropdown'
import * as popUp from '../../toastr'
import FormaDePagamentoService from '../../../app/service/contasAPagar/formaDePagamentoService'
import HandleErrorService from '../../../app/service/handleErrorService'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import TooltipButton from '../../tooltipButton'
import CheckBoxComponent from '../../relatorios/checkBoxComponent'

const cadastrarLabel = "Cadastrar Forma de Pagamento"

class InputChooseFormaDePagamento extends React.Component {

    constructor()
    {
        super()
        this.generalServices = new GeneralServices()
        this.formaDePagamentoService = new FormaDePagamentoService()
    }

    state = {

        formasDePagamentoList: [],

        displayDialog: false,
        displayCreateOrEditDialog: false,

        idFormaDePagamentoToEdit: null,

        tipoFormaDePagamentoASerCriada: '',
        inputTipoFormaDePagamentoASerCriadaErroClass: '',

        descricaoFormaDePagamentoASerCriadaOuEditada: '',
        inputDescricaoFormaDePagamentoASerCriadaOuEditadaErrorClass: '',

        diaVencimentoFormaDePagamentoASerCriada: '',
        displayDiaDeVencimento: false,
        inputDiaDeVencimentoErrorClass: '',
        errorDiaDeVencimentoaMessage: '',

        selectedFormaDePagamento: null,

        didUpdated: false,

        isEditDialog: false,
        
    }
    
    // componentDidMount(){
    //     console.log("mount!")
    // }

    componentDidUpdate(){
        // console.log("update: ", this.state.didUpdated)
        if(this.state.displayDialog && !this.state.didUpdated){
            this.setState({isEditDialog: false})
            this.search()
        }
    }

    search = () => {
        // console.log("search")
        this.setState({didUpdated: true})
        this.setState({loadingTable: true})
        
        this.formaDePagamentoService.search()
        .then(response => {
            this.setState({formasDePagamentoList: response.data})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loadingTable: false})
        })
    }

    resetView = () => {
        this.setState({
            inputTipoFormaDePagamentoASerCriadaErroClass: '',
            inputDescricaoFormaDePagamentoASerCriadaOuEditadaErrorClass: '',
            inputDiaDeVencimentoErrorClass: '',
            errorDiaDeVencimentoaMessage: ''
        })
    }

    checkDataCadastro = () => {
        
        let check = true

        if(!this.state.tipoFormaDePagamentoASerCriada){
            this.setState({inputTipoFormaDePagamentoASerCriadaErroClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }
        
        if(!this.state.descricaoFormaDePagamentoASerCriadaOuEditada){
            this.setState({inputDescricaoFormaDePagamentoASerCriadaOuEditadaErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        if(
            this.state.tipoFormaDePagamentoASerCriada === ConstantsUtil.tipoFormaDePagamentoCartaoDeCredito
            && !this.state.diaVencimentoFormaDePagamentoASerCriada
        ){
            this.setState({
                inputDiaDeVencimentoErrorClass: ConstantsUtil.primereactInputErrorClass,
                errorDiaDeVencimentoaMessage: 'Informe o dia de vencimento'
            })
            check = false            
        }

        return check

    }

    handleCreateOrEditFormaDePagamento = (obj) => {
        return this.state.isEditDialog ? this.formaDePagamentoService.edit(obj) : this.formaDePagamentoService.save(obj)
    }

    callSaveCadastroFormaDePagamento = () => {
        this.resetView()
        if(this.checkDataCadastro()){
            let obj = {
                id: this.state.idFormaDePagamentoToEdit,
                descricao: this.state.descricaoFormaDePagamentoASerCriadaOuEditada,
                tipo: this.state.tipoFormaDePagamentoASerCriada,
                diaVencimento: this.state.diaVencimentoFormaDePagamentoASerCriada,
            }
            this.handleCreateOrEditFormaDePagamento(obj)
            .then(response => {
                popUp.successPopUp("Forma de Pagamento Cadastrada com Sucesso!")
                this.hideCreationDialog()
                this.search()
            })
            .catch(error => {
                HandleErrorService.handleError(error)
            })
        }
    }

    hideCreationDialog = () => {
        this.setState({
            idFormaDePagamentoToEdit: null,
            tipoFormaDePagamentoASerCriada: '',
            descricaoFormaDePagamentoASerCriadaOuEditada: '',
            diaVencimentoFormaDePagamentoASerCriada: '',
            isEditDialog: false,
            displayCreateOrEditDialog: false
        })
    }

    hideDialog = async () => {
        await this.setState({displayDialog: false})
        this.setState({didUpdated: false})
        // if(this.props.reRenderEditDialog){
        //     this.props.reRenderEditDialog()
        // }
    }

    handleDescricaoChange = (event) => {
        const name = event.target.name
        const value = event.target.value
        this.setState({ [name]: value })
    }

    handleKeyPress = async (e) => {
        if (e.key === "Enter") {
            this.inputClick()
          }
    }

    handleDiaDeVencimentoChange = (event) => {
        const value = event.target.value
        this.setState({ diaVencimentoFormaDePagamentoASerCriada: value })
    }

    handleTipoChange = (event) => {
        const value = event.target.value
        const name = event.target.name
        this.setState({ [name]: value })
    }

    handleSelectionChange = async (event) => {

        let value = event.value

        await this.generalServices.sleep(100)
        if(
            this.state.selectedFormaDePagamento && value === null
            && !this.state.displayCreateOrEditDialog
        ){
            /*
            Significa que clicou em cima do item que estava selecionado antes (double click), por isso ficou null.
            // Mas, se preocupa com o caso de esse 2° click ter sido em cima do botão de editar. Neste caso, não significa que selecinou.
            */
            this.selectFormaDePagamento()
        } else{
            this.setState({selectedFormaDePagamento: value})
        }

    }

    selectFormaDePagamento = () => {
        this.props.handleSelectionChange(this.state.selectedFormaDePagamento)
        this.hideDialog()
    }

    limparFormaDePagamento = () => {
        this.props.handleLimparFormaDePagamento()
        this.hideDialog()
    }

    inputClick = () => {
        if(!this.props.disabled){
            this.setState({displayDialog: true})
        }
    }

    edit = async (selectedFormaDePagamento) => {
        // // console.log("edit tipoProduto: ", tipoProduto)
        // await this.setState({tipoProdutoToEdit: JSON.parse(JSON.stringify(tipoProduto))})
        // await this.setState({forceUpdate: true})
        this.setState({
            idFormaDePagamentoToEdit: selectedFormaDePagamento.id,
            tipoFormaDePagamentoASerCriada: selectedFormaDePagamento.tipo,
            descricaoFormaDePagamentoASerCriadaOuEditada: selectedFormaDePagamento.descricao,
            diaVencimentoFormaDePagamentoASerCriada: selectedFormaDePagamento.diaVencimento,
            isEditDialog: true,
            displayCreateOrEditDialog: true
        })
    }

    render(){

        const renderInput = () => {
            
            return (
                <>
                <label>Forma de Pagamento</label>
                <div className='row'>
                <div className='col-md-4'>
                    <input 
                        type="text"
                        className={"form-control " + this.props.inputErrorClass}
                        readOnly
                        value = {this.props.selectedFormaDePagamentoLabel}
                        placeholder="Selecione..."
                        onClick={this.inputClick}
                        onKeyDown={this.handleKeyPress}
                        disabled={this.props.disabled}
                    />
                    </div>
                    <div className='col-md-8'>
                    <CheckBoxComponent
                        label="Gravar Escolha da Forma de Pagamento?"
                        checked={this.props.gravarEscolhaFormaDePagamento}
                        handleCheckBoxChange={this.props.handleGravarEscolhaChange}
                    />                    
                </div>
                </div>
                </>
            )
        }

        const renderHTMLFormat = () => {
            if(this.props.noHTMLFormat){
                return (
                    <>
                    {renderInput()}
                    </>
                )
            }
            else {
                return (
                    <>
                    <div className="row">
                    <div className="col-md-12">
                    {renderInput()}
                    </div>
                    </div>
                    </>
                )
            }
        }

        const renderDiaDeVencimento = () => {
            if(this.state.tipoFormaDePagamentoASerCriada === ConstantsUtil.tipoFormaDePagamentoCartaoDeCredito){
                return (
                    <>
                        <br />
                        <div className="p-field">
                            <label>Dia de Vencimento</label>
                                <br />
                                <Dropdown
                                    className={this.state.inputDiaDeVencimentoErrorClass}
                                    value={this.state.diaVencimentoFormaDePagamentoASerCriada}
                                    options={ConstantsUtil.getDiasDoMesList()}
                                    onChange={this.handleDiaDeVencimentoChange}
                                    optionLabel="label"
                                    filter
                                    showClear
                                    filterBy="label"
                                    placeholder="Selecione"
                                    emptyMessage=""
                                    emptyFilterMessage=""
                                />
                                <small className="p-error">{this.state.errorDiaDeVencimentoaMessage}</small>   
                        </div>
                    </>
                )
            }
        }

        const actionBody = (formaDePagamento) => {
            if(!formaDePagamento.fixoSistema)
            return (
                <React.Fragment>
                    <TooltipButton
                        tooltip = "Editar Forma de Pagamento"
                        icon={<i className="pi pi-pencil" style={{fontSize: '1em'}}></i>}
                        onClick={() => this.edit(formaDePagamento)}
                        style={ {maxHeight: '25px', maxWidth: '25px'} }
                    />
                </React.Fragment>
            );
        }

        const renderTable = () => {

            return (

                <DataTable
                    ref={this.dt}
                    value={this.state.formasDePagamentoList}
                    className="p-datatable-sm small-font"
                    rowHover
                    emptyMessage="Não há formas de pagamento cadastradas."
                    showGridlines
                    selection={this.state.selectedFormaDePagamento}
                    onSelectionChange={this.handleSelectionChange}
                    loading={this.state.loadingTable}
                    dataKey="id"
                >

                    <Column selectionMode="single" headerStyle={{ width: '3rem' }} />

                    <Column
                        header="Descrição"
                        field="descricao"
                        sortable
                        style ={ {width: '200px'} }
                        // filter filterElement={perfilFilterElement}
                    />

                    <Column
                        header="Tipo"
                        field="tipo"
                        sortable
                        style ={ {width: '200px'} }
                        // filter filterElement={perfilFilterElement}
                        body={rowData => {
                            for(let item of ConstantsUtil.tipoFormaDePagamentoSelectList){
                                if(item.value === rowData.tipo)
                                    return item.label
                            }
                        }}                        
                    />

                    <Column
                        header="Dia de Vencimento"
                        field="diaVencimento"
                        sortable
                        style ={ {width: '200px'} }
                        // filter filterElement={perfilFilterElement}
                    />

                    <Column field="fixoSistema" header="Fixo do Sistema"
                        sortable
                        style ={ {width: '100px'} }
                        body={rowData => rowData.fixoSistema ? "Sim" : "Não"}
                    />

                    <Column header="Editar" body={actionBody} style ={ {width: '140px'} } />

                </DataTable>

            )
        }

        const renderDialog = () => {

            return (
                <Dialog
                    header={"Forma de Pagamento"}
                    visible={this.state.displayDialog}
                    modal
                    style={{ width: '90vw' }}
                    footer={dialogFooter(this.selectFormaDePagamento, this.hideDialog)}
                    onHide={this.hideDialog}
                >

                    <Button
                        label={cadastrarLabel}
                        icon="pi pi-plus"
                        className=" small-font"
                        style={{maxHeight: '25px', marginLeft: '10px'}}
                        onClick={() => this.setState({displayCreateOrEditDialog: true})}
                    />

                    <Button
                        label={"Limpar Forma de Pagamento Selecionada"}
                        icon="pi pi-times"
                        className="small-font p-button-danger"
                        style={{maxHeight: '25px', marginLeft: '10px'}}
                        onClick={this.limparFormaDePagamento}
                    />

                    <br />
                    <br />

                    {renderTable()}

                </Dialog>

            )

        }

        const dialogFooter = (callSaveFunction, hideDialogFunction) => {
            return (
                <DialogFooter save = {callSaveFunction} hideDialog = {hideDialogFunction}/>
            )
        } 

        const renderCreationDialog = () => {

            return (

                <Dialog
                    header={ this.state.isEditDialog ? "Editar Forma de Pagamento" : cadastrarLabel}
                    visible={this.state.displayCreateOrEditDialog}
                    modal = {true}
                    className="p-fluid"
                    style={{ width: '30%' }}
                    footer={dialogFooter(this.callSaveCadastroFormaDePagamento, this.hideCreationDialog)}
                    onHide={this.hideCreationDialog}
                >

                    <div className="p-field">
                        <label>Tipo</label>
                        <SelectMenu
                            className={"form-control " + this.state.inputTipoFormaDePagamentoASerCriadaErroClass}
                            name="tipoFormaDePagamentoASerCriada"
                            list={ConstantsUtil.tipoFormaDePagamentoSelectList} 
                            value={this.state.tipoFormaDePagamentoASerCriada}
                            onChange={this.handleTipoChange}
                            // disabled
                        />
                        <div className="invalid-feedback">Informe o Tipo</div>
                    </div>

                    <br />
                    <div className="p-field">
                        <label>Descrição</label>
                        <input
                            type="text"
                            // autoFocus
                            name="descricaoFormaDePagamentoASerCriadaOuEditada"
                            className={"form-control " + this.state.inputDescricaoFormaDePagamentoASerCriadaOuEditadaErrorClass}
                            value = {this.state.descricaoFormaDePagamentoASerCriadaOuEditada}
                            onChange={this.handleDescricaoChange}
                            onKeyDown={e => e.key === 'Enter' && this.callSaveCadastroFormaDePagamento()}
                        />    
                        <div className="invalid-feedback">{"Informe a descrição"}</div>
                    </div>

                    {renderDiaDeVencimento()}

                </Dialog>

            )

        }

        return(
            <>
            
                {renderHTMLFormat()}

                {renderDialog()}

                {renderCreationDialog()}
                
            </>
        )

    }


}

export default InputChooseFormaDePagamento